import { assignTrimmedField } from '@klear/schema/patch'
import isNumber from 'lodash/isNumber'
import values from 'lodash/values'
import type { OrderCreateWire } from '@klear/order/order.wire'
import toNumber from 'lodash/toNumber'

export type OrderForm = {
  customerId: string
  description: string
}

export type OrderFormErrorMap = Record<string, string | undefined>

export const EMPTY_ORDER_FORM: OrderForm = {
  customerId: '',
  description: ''
}

export function validateOrderForm(form: OrderForm): OrderFormErrorMap {
  const errors: OrderFormErrorMap = {}
  if (!form.customerId.trim()) {
    errors.customerId = 'Customer is required'
  }
  return errors
}

export function hasOrderFormErrors(errors: OrderFormErrorMap): boolean {
  return values(errors).some(Boolean)
}

export function clearOrderFormErrors(
  errors: OrderFormErrorMap,
  paths: readonly (keyof OrderForm | string)[]
): OrderFormErrorMap {
  const next = { ...errors }
  for (const path of paths) {
    delete next[path]
  }
  return next
}

export type OrderFieldChange = <K extends keyof OrderForm>(field: K, value: OrderForm[K]) => void

function customerIdAsNumber(value: string): number {
  const parsed = toNumber(value)
  return isNumber(parsed) && isFinite(parsed) ? parsed : 0
}

export function orderFormToCreateWire(form: OrderForm): OrderCreateWire {
  const wire: OrderCreateWire = {
    customerId: customerIdAsNumber(form.customerId.trim())
  }

  assignTrimmedField(wire, 'description', form.description)

  return wire
}
